import * as React from 'react';

export function IconUmbrella(): JSX.Element {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             width="34"
             height="34"
             viewBox="0 0 34 34">
            <path d="M17,17v7.912q0,2,1.376,2c.777,0,1.279-.5,1.457-1.416"
                  fill="none"
                  stroke="#979797"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M24.558,15.086a7.558,7.558,0,0,0-15.116,0Z"
                  fill="none"
                  fillRule="evenodd"
                  stroke="#979797"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    );
}
